@if (!input?.suppressTabDisplay) {
    <ws-ace-tabs
        class="pb-2"
        [attr.vertical]="input?.enableVerticalDisplay || null"
        [attr.active-tab]="input?.activeTab || null">
        @for (tab of input.tabs || []; track $index) {
            <ws-ace-tab [label]="tab.label"
                        [active]="(tab.key === input?.activeTab || tab.label === input?.activeTab) || null"
                        (tabActivated)="onTabClick(tab)">
            </ws-ace-tab>
        }
    </ws-ace-tabs>
}
<div class="active-content">
    <ng-content></ng-content>
</div>
